<!-- Floating Widget Container -->
<div
  class="fixed bottom-8 right-8 z-50 flex flex-col items-end gap-4"
  clickOutside
  (clickOutside)="closePanel()"
>
  <!-- Preview Panel -->
  @if (viewType) {
    <div
      class="relative w-[440px] h-[80vh] max-h-[700px] mb-2 rounded-2xl overflow-hidden shadow-2xl border border-[#e6b012]/30 animate-in slide-in-from-right-5 fade-in zoom-in-95 duration-300"
    >
      <!-- Background -->
      <div class="absolute inset-0 bg-[#0e3b2e]"></div>

      <!-- Animated Gradient Orbs -->
      <div class="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          class="absolute -top-20 -right-20 w-40 h-40 bg-[#e6b012]/15 rounded-full blur-3xl animate-pulse"
        ></div>
        <div
          class="absolute -bottom-20 -left-20 w-40 h-40 bg-[#e6b012]/10 rounded-full blur-3xl animate-pulse delay-700"
        ></div>
      </div>

      <!-- Header -->
      <div
        class="relative z-10 flex items-center justify-between px-5 py-4 bg-[#0a2e23] border-b border-[#e6b012]/30"
      >
        <div class="flex items-center gap-3">
          <div class="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center border border-white/10">
            @if (activeWidget?.type === 'img') {
              <img
                [src]="activeWidget?.src"
                class="size-8 object-contain"
                [alt]="activeWidget?.label"
              />
            } @else {
              <app-svg-icon [name]="activeWidget?.icon || ''" class="w-5 h-5 text-[#e6b012]" />
            }
          </div>
          <span class="text-white font-bold text-base">{{ activeWidget?.label }}</span>
        </div>

        <button
          (click)="closePanel()"
          class="w-8 h-8 rounded-lg bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-all duration-200 hover:rotate-90 group cursor-pointer"
        >
          <svg
            class="w-4 h-4 text-white transition-transform group-hover:scale-110"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <!-- Content -->
      <div class="relative z-10 h-[calc(100%-72px)] bg-gray-100">
        @switch (viewType) {
          @case ('msaadaAi') {
            <app-msaada-ai />
          }
          @case ('chatCenter') {
            <app-chat-center />
          }
          @case ('accessibility') {
            <app-accessibility />
          }
        }
      </div>
    </div>
  }

  <!-- Widget Buttons - Hidden when viewType is set -->
  @if (!viewType) {
    <div class="flex flex-col gap-3.5 animate-in fade-in slide-in-from-bottom-4 duration-300">
      @for (widget of widgets; track widget.id) {
        <div
          class="group relative flex items-center animate-subtle-float"
          [style.animation-delay]="$index * 100 + 'ms'"
        >
          <button
            (click)="setViewType(widget.id)"
            class="w-14 h-14 rounded-full border-2 border-[#e6b012] bg-[#0e3b2e] hover:bg-[#07231a] text-white font-semibold cursor-pointer transition-all duration-300 ease-out hover:scale-110 shadow-xl flex items-center justify-center"
          >
            @if (widget.type === 'img') {
              <img [src]="widget.src" [alt]="widget.label" class="w-full h-full object-cover p-2.5" />
            } @else {
              <app-svg-icon [name]="widget.icon" class="size-7 text-[#e6b012]" />
            }
          </button>

          <span
            class="absolute right-[68px] whitespace-nowrap bg-[#0e3b2e] text-[#e6b012] font-bold text-xs px-3.5 py-1.5 rounded-full border border-[#e6b012]/40 shadow-lg opacity-0 translate-x-2.5 transition-all duration-250 ease-out pointer-events-none group-hover:opacity-100 group-hover:translate-x-0"
          >
            {{ widget.label }}
          </span>
        </div>
      }
    </div>
  }
</div>
